<template>
    <div >
        <navbar-tournoi
            :club="club"
            :tournoi="tournoi"
            :parties="parties"
            :role="role"
            display="list"
            @nav="setNav"
            @back="back"
            v-if="showMenu"
        />
      
        &nbsp;
        <div class="search g_desktopOn">
            <div style="text-align:left;">
                    <div style="float:left">
                    <span class="title is-4">Liste des joueurs</span> &nbsp;
                    
                    </div>
                    <div style="float:right"  v-if="tournoi.state!='FINISH'">
                      
                      <s-input-search v-model="search" placeholder="Rechercher" theme="is-info is-normal" themeEraser="is-warning"
                    width="200px"/>&nbsp;
                    
                    <span v-if="classementPagination.length!=0 && club">
                     <s-button icon="file-pdf" theme="is-info is-normal" label="Résultat vierge en pdf" 
                    @onclick="generateReportVierge()" />
                &nbsp;
                    <s-button icon="file-pdf" theme="is-info is-normal" label="Exporter en pdf" @onclick="generateReport()"/>
                    
                           
                    </span>
                      &nbsp;<s-button   theme="is-success" icon="play" label="Reprendre" @onclick="$emit('viewGame')" />
                    <vue-html2pdf
                        :show-layout="false"
                        :float-layout="true"
                        :enable-download="true"
                        :preview-modal="false"
                        :paginate-elements-by-height="200"
                        filename="hee hee"
                        :pdf-quality="2"
                        :manual-pagination="true"
                        pdf-format="a4"
                        pdf-orientation="portrait"
                        pdf-content-width="800px"
                        :html-to-pdf-options="options"
                        
                        ref="html2PdfVierge"
                        v-if="classementPagination.length!=0 && club"
                    >
                        <pdf-resultat-vierge 
                            v-if="classementPagination.length!=0" 
                            :tournoi="tournoi" slot="pdf-content" 
                            :club="club" 
                            :classement="classementPagination" :nbParties="nbParties"
                            :mode="0"
                            />
                    </vue-html2pdf>
                    <vue-html2pdf
                                :show-layout="false"
                                :float-layout="true"
                                :enable-download="true"
                                :preview-modal="false"
                                :paginate-elements-by-height="420"
                                filename="hee hee"
                                :pdf-quality="2"
                                :manual-pagination="true"
                                pdf-format="a4"
                                pdf-orientation="portrait"
                                pdf-content-width="800px"
                                :html-to-pdf-options="options"
                                ref="html2PdfList"
                                
                            >
                                <pdf-resultat v-if="classementPagination.length!=0" 
                                    :tournoi="tournoi" 
                                    slot="pdf-content" 
                                    :club="club" 
                                    :classement="classementPagination" 
                                    :nbParties="nbParties"
                                    :mode="1"
                                />
                            </vue-html2pdf>
                </div>
           </div>
        </div>
        
        <div class="g_menuMobile" v-show="showMenu">
            <table class="g_menuFooter">
                <tr>
                    <td colspan="4" class="g_headerFooter">
                        Liste des joueurs
                    </td>
                </tr>
                <tr>
                    <td style="width:80%;vertical-align:middle">
                        <s-input v-model="search" placeholder="Rechercher par le nom" theme="is-info" icon="search" />
                    </td>
                    <td>
                        <div class="g_buttonFooter">
                        <s-button theme="is-success" icon="play" label="" @onclick="$emit('viewGame')" />
                        </div>
                        Reprendre
                    </td>
                </tr>
            </table>
        </div>
        <div class="array_classement">
        <div class="sheader g_desktopOn">
            <table class="table  is-striped is-fullwidth tableClassement">
                <tr>
                    <th >
                        <div v-on:click="sortfield('captain')" :class="sortBy!='captain' ? '' : 'sortBy'">
                       
                        <s-l id="resultat_array_nom">Nom</s-l>
                        <div style="float:right;vertical-align:top">
                            <span :class="sortBy!='captain' ? 'icon' : 'icon has-text-success'">
                                <i :class="asc ? 'fas fa-sort-down' : 'fas fa-sort-up'"></i>
                            </span>
                        </div>
                        </div>
                    </th>
                     <th  v-on:click="sortfield('numero')" :class="sortBy!='numero' ? 'numero' : 'sortBy'">
                        <s-l id="resultat_array_numero">Numéro</s-l>
                        <div style="float:right;vertical-align:top">
                         <span  :class="sortBy!='numero' ? 'icon' : 'icon has-text-success'">
                            <i :class="asc ? 'fas fa-sort-down' : 'fas fa-sort-up'"></i>
                        </span>
                        </div>
                    </th>
                    <th v-if="tournoi.options.mode!='FORME'  && (role=='admin' || role=='owner')">
                        Inscription
                    </th>
                     
                    <th >
                        <div v-on:click="sortfield('nbPartieJoues')" :class="sortBy!='nbPartieJoues' ? '' : 'sortBy'">
                        
                         <s-l id="resultat_array_joues">Joués</s-l>
                         <div style="float:right;vertical-align:top">
                          <span  :class="sortBy!='nbPartieJoues' ? 'icon' : 'icon has-text-success'">
                            <i :class="asc ? 'fas fa-sort-down' : 'fas fa-sort-up'"></i>
                        </span>
                         </div>
                        </div>
                    </th>
                    <th v-for="(index) in parties.length" >
                        <div >
                         <s-l id="resultat_array_partie_listJoueurs" :v="index">Partie %v </s-l> 
                         </div>

                    </th>
                    <th >
                        <div v-on:click="sortfield('nbPartieGagne')" :class="sortBy!='nbPartieGagne' ? '' : 'sortBy'">
                         <s-l id="resultat_array_gagnes">Gagnés</s-l>
                         <div style="float:right;vertical-align:top">
                              <span  :class="sortBy!='nbPartieGagne' ? 'icon' : 'icon has-text-success'">
                                <i :class="asc ? 'fas fa-sort-down' : 'fas fa-sort-up'"></i>
                            </span>
                         </div>
                        </div>
                    </th>
                    <th >
                        <div v-on:click="sortfield('diff')" :class="sortBy!='diff' ? '' : 'sortBy'">
                         <s-l id="resultat_array_goal">Goal Average</s-l>
                         <div style="float:right;vertical-align:top">
                            <span  :class="sortBy!='diff' ? 'icon' : 'icon has-text-success'">
                                <i :class="asc ? 'fas fa-sort-down' : 'fas fa-sort-up'"></i>
                            </span>
                         </div>
                        </div>
                    </th>
                </tr>
                </table>
            </div>
        <div>
        <table class="tableClassement table  is-striped is-fullwidth" v-show="classement.length!=0">
            <thead class="g_mobileOn">
            <tr>
                    <th >
                        <div v-on:click="sortfield('captain')" :class="sortBy!='captain' ? '' : 'sortBy'">
                        
                        <s-l id="resultat_array_nom">Nom</s-l>
                        
                         <div style="float:right;vertical-align:top">
                        <span :class="sortBy!='captain' ? 'icon' : 'icon has-text-success'">
                            <i :class="asc ? 'fas fa-sort-down' : 'fas fa-sort-up'"></i>
                        </span>
                        </div>
                        </div>
                    </th>
                     <th  v-on:click="sortfield('numero')" :class="sortBy!='numero' ? 'numero' : 'sortBy'">
                        <s-l id="resultat_array_numero">Numéro</s-l>
                         <div style="float:right;vertical-align:top">
                         <span  :class="sortBy!='numero' ? 'icon' : 'icon has-text-success'">
                            <i :class="asc ? 'fas fa-sort-down' : 'fas fa-sort-up'"></i>
                        </span>
                         </div>
                    </th>
                    <th v-if="tournoi.options.mode!='FORME'  && (role=='admin' || role=='owner')">
                        Inscription
                    </th>
                     
                    <th >
                        <div v-on:click="sortfield('nbPartieJoues')" :class="sortBy!='nbPartieJoues' ? '' : 'sortBy'">
                         <s-l id="resultat_array_joues">Joués</s-l>
                          <div style="float:right;vertical-align:top">
                          <span  :class="sortBy!='nbPartieJoues' ? 'icon' : 'icon has-text-success'">
                            <i :class="asc ? 'fas fa-sort-down' : 'fas fa-sort-up'"></i>
                        </span>
                          </div>
                        </div>
                    </th>
                    <th v-for="(index) in parties.length" >
                        <div >
                         <s-l id="resultat_array_partie_listJoueurs" :v="index">Partie %v </s-l> 
                         </div>

                    </th>
                    <th >
                        <div v-on:click="sortfield('nbPartieGagne')" :class="sortBy!='nbPartieGagne' ? '' : 'sortBy'">
                         <s-l id="resultat_array_gagnes">Gagnés</s-l>
                          <div style="float:right;vertical-align:top">
                          <span  :class="sortBy!='nbPartieGagne' ? 'icon' : 'icon has-text-success'">
                            <i :class="asc ? 'fas fa-sort-down' : 'fas fa-sort-up'"></i>
                        </span>
                          </div>
                        </div>
                    </th>
                    <th >
                        <div v-on:click="sortfield('diff')" :class="sortBy!='diff' ? '' : 'sortBy'">
                         <s-l id="resultat_array_goal">Goal Average</s-l>
                          <div style="float:right;vertical-align:top">
                         <span  :class="sortBy!='diff' ? 'icon' : 'icon has-text-success'">
                            <i :class="asc ? 'fas fa-sort-down' : 'fas fa-sort-up'"></i>
                        </span>
                          </div>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody>
            <tr v-for="(classement_item, indexClassement) in classement"  v-if="classement_item && searchBy(classement_item)">
               <td>
                    <div class="nomprenom" v-if="classement_item.captain!=''">
                        {{classement_item.captain}}
                    </div>
                    <div class="nomprenom" v-if="classement_item.captain==''">
                        <i>Invité</i>
                    </div>
                    <div v-if="classement_item.coequipier1!=''">
                        <div class="nomprenom" >
                            {{classement_item.coequipier1}}
                        </div>
                    </div>
                    <div v-if="classement_item.coequipier2!=''">
                        <div class="nomprenom">
                            {{classement_item.coequipier2}}
                        </div>
                    </div>
                </td>
                 <td>
                    {{classement_item.numero+1}}
                </td>
                <td v-if="tournoi.options.mode!='FORME' && (role=='admin' || role=='owner')">
                    <b v-if="classement_item.inscriptionValide">
                        <s-button afterIcon="check" theme="is-success is-small" label="Validé"
                            @onclick="validInscription(classement_item.captainId)"
                            :role="role"/>
                    </b>
                    <b v-else style="color:red">
                        <s-button  theme="is-danger  is-small" label="Non Validé"
                            @onclick="validInscription(classement_item.captainId)"
                            :role="role"/>
                    </b> 
                </td>
               
                <td>
                    {{classement_item.nbPartieJoues}}
                </td>
                <td  v-for="(index) in parties.length"  >
                    {{classement_item.partieScore[index-1]}}
                </td>
               
                 <td>
                   {{classement_item.nbPartieGagne}}
                </td>
                 <td>
                    {{classement_item.diff}}
                </td>
            </tr>
            </tbody>
            
            
        </table>
        </div>
        </div>

        
        <div style="height:100px">
            &nbsp;
        </div>
        
    </div>
  
    
</template>

<style lang="scss" scoped>
    .search {
       background-color: var(--backgound-color);
       position: fixed;
       top: 50px;
       padding-top: 10px;
       padding-left: 10px;
       padding-right: 10px;
       padding-bottom: 10px;
       z-index: 2;
       width: 100%;
    }
    .desincription {
        border-radius: 10px;
        border: thin solid red;
        float: right;
    }
    .desincription:hover {
        cursor: pointer;
    }
    .valid {
        border-radius: 10px;
        border: thin solid rgb(5, 156, 5);
        float: right;
    }
    .valid:hover {
        cursor: pointer;
    }
    @media screen and (max-width: 420px) and (min-height: 600px) {
         .array_classement {
            width: 100%;
            margin-top: 40px;
            overflow: auto;
            max-height: 500px;
        }
     }
       @media screen and (max-width: 420px) and (min-height: 700px) {
          .array_classement {
            width: 100%;
            margin-top: 40px;
            overflow: auto;
            max-height: 550px;
        }
      }
     @media screen and (min-width: 420px) {
         .sheader {
            position: fixed;
            top: 110px;
            z-index: 4;
            width: 100%;    
            box-shadow: 0px 7px 7px -5px rgba(0,0,0,0.71);
            -webkit-box-shadow: 0px 7px 7px -5px rgba(0,0,0,0.71);
            -moz-box-shadow: 0px 7px 7px -5px rgba(0,0,0,0.71);
         }
         .array_classement {
            width: 100%;
            max-height: 600px;
            margin-top: 130px;
           
        }
     }
    
    .sortBy {
        font-weight: bold;
        color: rgb(137, 245, 137);
    }
    
    .tableClassement td,
    th {
        border: 1px solid #000;
        width: 140px;
        text-align: center;
    }
    .tableClassement th {
        background-color:var(--bluebg);
        text-align: center;
        color: white;
        position:sticky;
        top: 0;
        vertical-align: middle;
        
    }

    table.tableClassement {
        table-layout: fixed;
        position: relative;
        color: black;
        font-weight: bolder;
    }
    @media screen and (max-width: 420px) {
        .tableClassement td:first-child, th:first-child {
            position:sticky;
            left:0;
            z-index:1;
            width: 150px;
            font-size: 12px;
            background-color:var(--bluebg);
            color: white;
            
        }
    }
    @media screen and (min-width: 420px) {
        .tableClassement td:first-child, th:first-child {
            position:sticky;
            left:0;
            z-index:1;
            width: 150px;
            background-color:var(--bluebg);
            color: white;
        }
    } 
    
   
    .tableClassement th:first-child {z-index:20;background-color:var(--bluebg);}
    

</style>
<style  scoped>
    th {
        font-size: 12px;
    }
    th:hover {
        cursor: pointer;
        color: rgb(21, 189, 21);
    }
    .header {
        overflow-y: scroll;
        
    }
    .header div {
        display: inline-block;
        border: thin solid black;
        background-color: rgb(39, 121, 177);
        color: white;
        text-align: center;
        font-size: 18px;
        font-weight: bolder;
    }
    .classement div {
        display: inline-block;
        border: thin solid black;
        font-size: 14px;
        height: 40px;
        padding-top: 3px;
    }
    .nom {
      
        text-align: left;
        
    }
   
    .score {
        width: 17%;
        font-weight: bold;
        text-align: center;
    }




</style>
<script>
import tournoi_fct from "@/firebase/tournoi"
import firebase_api from "@/firebase/firebase_api"
import navbarTournoi from "@/views/tournoi/navbar.vue"
import navbarFooterTournoi from "@/views/tournoi/navbarfooter.vue"
import VueHtml2pdf from 'vue-html2pdf';
import PdfResultat from "@/views/tournoi/export/pdfresultat.vue"
import PdfResultatVierge from "@/views/tournoi/export/pdfresultatVierge.vue"
export default {
    props: ["club","tournoi","role","menu"],
    components: {
        navbarTournoi,
        navbarFooterTournoi,
        VueHtml2pdf,
        PdfResultat,
        PdfResultatVierge
    },
    computed: {
        nbParties: {
            get() {
                if (this.tournoi) {
                    if (this.tournoi.state=='FINISH')
                        return this.tournoi.options.nbParties;
                    else
                        return this.parties.length;
                }
                return 0;
            }
        },
         showMenu: {
            get() {
                if (typeof(this.menu)=="undefined")
                    return true;
                else
                    return false;
            }
            
        },
    },
    data() {
        return {
            classement: [],
            classementPagination: [],
            parties: [],
            finish: true,
            modalCloturer: false,
            sortBy: "captain",
            asc: true,
            search: "",
            options: {
                marge: [10, 10],
                filename: this.filename(),
                html2canvas: {
                scale: window.devicePixelRatio,
                useCORS: true,
                proxy: 'https://firebasestorage.googleapis.com'
                },
            }
        }
    },
    methods: {
        back() {
            
            this.$emit('nav','tournois'); 
           
        },
        validInscription(idJoueur) {
            var index = this.tournoi.joueurs.findIndex(joueur=>joueur.id === idJoueur);
            if (index!=-1) {
                this.tournoi.joueurs[index].inscriptionValide = !this.tournoi.joueurs[index].inscriptionValide
            }
            tournoi_fct.object.set(this.club, this.tournoi, ()=>{
                this.init();
            })
        },
       
        filename() {
                var filename = this.club.id;
                var today = new Date(this.tournoi.date);
                return filename + " RESULTAT " + today.getFullYear() + today.getMonth() + today.getDate();
            },
            
        setNav(nav) {
          
            this.$emit("nav",nav)
        },
        searchBy(classement_item) {
            if (this.search == '')
                return true;
            else {
                return (classement_item.captain.toUpperCase().indexOf(this.search.toUpperCase()) == 0)
            }
        },
        sortfield(field) {
            
            this.asc = !this.asc;
            this.sortBy = field;
            if (this.asc)
                this.classement.sort((a,b)=> {
                    if(a[field] < b[field]) { return -1; }
                    return 0;
                });
            else
                this.classement.sort((a,b)=> {
                    if(a[field] > b[field]) { return -1; }
                    return 0;
                });
            this.initListPagination();
          
        },
        cloturer() {
            
            tournoi_fct.object.setFinish(this.club, this.tournoi, this.classement, ()=>{
                this.modalCloturer = false;
            })
        },
         generateReportVierge () {
            this.$refs.html2PdfVierge.generatePdf()
        },
         generateReport () {
           
            this.$refs.html2PdfList.generatePdf()
        },
        initListPagination() {
            var indexPagination = 0;
            var compteur=0;
            var maxLigne = 38;
            
            this.classementPagination = [];
            this.classement.forEach((classementItem, indexClassement)=>{
                
                if (compteur<maxLigne) {
                    if (typeof(this.classementPagination[indexPagination]) == "undefined") {
                        this.classementPagination[indexPagination] = [];
                    }
                    classementItem.rang = indexClassement;
                    this.classementPagination[indexPagination].push(classementItem);
                    compteur++;
                }
                else {
                    classementItem.rang = indexClassement;
                    this.classementPagination[indexPagination].push(classementItem);
                    indexPagination++;
                    compteur=0;
                }
            })
        
        },
        async init() {
            if (this.tournoi.state=='FINISH') {
                
                this.classement = this.tournoi.classement
            }
            else if (this.tournoi.state=='INPROGRESS') {
                var parties = await firebase_api.api.getDb().collection("club").doc(this.club.id)
                .collection("tournois").doc(this.tournoi.id).collection("parties").get();
                this.parties = [];
                for (var indicePartie in parties.docs) {
                    var partie = parties.docs[indicePartie];
                    var partieData = partie.data();
                    this.finish = (partieData.state == "FINISH") && this.finish;
                    var partieItem = {
                        equipes: []
                    }
                    var equipesDoc = await partie.ref.collection("equipes").get();
                        for (var indiceEquipe in equipesDoc.docs) {
                        var equipe = equipesDoc.docs[indiceEquipe];
                        partieItem.equipes.push(equipe.data());
                                if (indiceEquipe == equipesDoc.docs.length - 1) {
                                    this.parties.push(partieItem);            
                                    if (indicePartie == parties.docs.length - 1) {
                                        
                                        this.classement = tournoi_fct.object.resultatTournoi(this.parties, this.tournoi);
                                        this.asc = false;
                                       
                                        this.sortfield("captain");
                                       /* this.classement.sort((a,b)=> {
                                            return b.score - a.score || b.diff - a.diff;
                                        });*/
                                        
                                    }
                                }
                                    
                                
                            }
                        }
                        
                }
                else {
                    // mettre ici la liste de sjoueurs non par parties mais par la liste tout simplement
                }
            }
                    
                    
            
            
        
    },
    async mounted() {
        await this.init();
        this.initListPagination();

    }
}
</script>